import { Box, Link, Typography, styled } from '@mui/material';

export const UploadedFileListItemText = styled(Typography)({
	maxWidth: '40%',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const UploadedFileListItemLink = styled(Link)({
	display: 'block',
	overflow: 'hidden',
	whiteSpace: 'nowrap',
	textOverflow: 'ellipsis',
});

export const AnnotatedFileWrapper = styled(Box)({
	display: 'flex',
	alignItems: 'center',
	gap: '12px',
	marginLeft: '4px',
	padding: '12px 16px',
	background: '#feebee',
	borderRadius: '8px',
});
